/**
 * Configurazione Stripe
 * 
 * IMPORTANTE: Usa questo file solo per lo sviluppo locale.
 * In produzione, utilizza variabili d'ambiente o servizi di gestione dei segreti.
 */

// Chiave pubblica (publishable key) - Può essere inclusa nel frontend
export const STRIPE_PUBLISHABLE_KEY = "pk_live_51ROHkVGGEd7vw2EoldVncU0j4nHVvu5f2HuNtObh8d2A1MbRvejGzkbZJA2eOT9Rx7aFYkCgchdpL5EmuYlf9wKU006TXgP6qG";

// La chiave segreta NON deve essere inclusa nel frontend.
// Questo oggetto è utilizzato solo dal componente di configurazione per mostrare lo stato.
export const STRIPE_CONFIG = {
  keyPreview: "Configurata via file .env sul server"
};

// Pacchetti di crediti disponibili
export const CREDIT_PACKAGES = [
  {
    id: 'basic',
    name: 'Basic Plan',
    price: 4.99,
    credits: 500,
    description: 'Perfect for beginners. Get 500 credits for quick profile analyses.'
  },
  {
    id: 'standard',
    name: 'Standard Plan',
    price: 9.99,
    credits: 1500,
    description: 'Most popular. Get 1500 credits for a more comprehensive analysis experience.'
  },
  {
    id: 'premium',
    name: 'Premium Plan',
    price: 14.99,
    credits: 3000,
    description: 'Best value. Get 3000 credits for extensive profile analysis.'
  }
]; 